"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _striptags = _interopRequireDefault(require("striptags"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize4"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus3"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Form = _interopRequireDefault(require("./Form"));
var _style = _interopRequireDefault(require("./style.css"));
var _index = require("../index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PinnedContentSection = function PinnedContentSection(props) {
  var draggableOffset = props.draggableOffset,
    title = props.title,
    summary = props.summary,
    content = props.content,
    formikBag = props.formikBag,
    moduleIndex = props.moduleIndex,
    surveyHandle = props.surveyHandle;
  var prefix = (0, _get2["default"])(formikBag, 'values.currentPrefix', '');
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  function getFullPath() {
    var path = "values.".concat(prefix, ".pinnedContent");
    if ((moduleIndex || moduleIndex === 0) && surveyHandle) {
      path += ".".concat(moduleIndex, ".").concat(surveyHandle);
    } else if (moduleIndex || moduleIndex === 0) {
      path += ".".concat(moduleIndex, ".topLevel");
    } else {
      path += '.topLevel';
    }
    return path;
  }
  function handleDelete(indexToDelete, displayName) {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?',
      description: /*#__PURE__*/_react["default"].createElement("span", null, "You are about to delete pinned content ", /*#__PURE__*/_react["default"].createElement("b", null, displayName)),
      confirmLabel: 'Yes',
      abortLabel: 'No'
    }).then(function () {
      var path = getFullPath();
      var original = (0, _get2["default"])(formikBag, path, []) || [];
      var updated = original.filter(function (p, index) {
        return index !== indexToDelete;
      });
      formikBag.setFieldValue(path.replace(/^values\./, ''), updated);
      // modulesTouched is dummy key to force Save button to highlight
      formikBag.setFieldTouched('pinnedTouched', true);
      (0, _cccisdNotification["default"])('Pinned Content deleted successfully!');
    });
  }
  function handleDragEnd(result) {
    if (!(result !== null && result !== void 0 && result.destination)) {
      return;
    }
    var path = getFullPath();
    var indexFrom = result.source.index;
    var indexTo = result.destination.index;
    var original = (0, _get2["default"])(formikBag, path, []) || [];
    var updated = [];
    for (var i = 0; i < original.length; i++) {
      var valToPush = original[i];
      if (i === indexTo) {
        valToPush = original[indexFrom];
      }
      // moving item up the list
      else if (indexTo < indexFrom && i > indexTo && i <= indexFrom) {
        if (i > indexTo && i <= indexFrom) {
          valToPush = original[i - 1];
        }
      }
      // moving item down the list
      else if (indexTo > indexFrom && i >= indexFrom && i < indexTo) {
        valToPush = original[i + 1];
      }
      updated.push(valToPush);
    }
    formikBag.setFieldValue(path.replace(/^values\./, ''), updated);
    // modulesTouched is dummy key to force Save button to highlight
    formikBag.setFieldTouched('pinnedTouched', true);
  }
  function renderContent(contentItem, i) {
    var _contentItem$headingE;
    var displayName = _index.pinnedContentTypeOptions[contentItem.type] + (contentItem.headingEn ? " - ".concat((0, _striptags["default"])(((_contentItem$headingE = contentItem.headingEn) === null || _contentItem$headingE === void 0 ? void 0 : _contentItem$headingE.content) || contentItem.headingEn).replace(/&nbsp;/g, ' ').replace(/\*/g, '')) : '');
    return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
      key: i,
      draggableId: i + '',
      index: i
    }, function (provided, snapshot) {
      if (snapshot.isDragging) {
        provided.draggableProps.style.left -= draggableOffset.x;
        provided.draggableProps.style.top -= draggableOffset.y;
      }
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: provided.innerRef
      }, provided.draggableProps, {
        className: _style["default"].pinnedDraggable
      }), /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.dragHandleProps, {
        className: _style["default"].icon
      }), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-success",
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        contentStyle: {
          maxWidth: '1300px'
        },
        size: "calc(100vw - 50px)",
        title: 'Add pinned content to ' + title,
        render: function render(_ref) {
          var closeModal = _ref.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_Form["default"], _extends({
            closeModal: closeModal
          }, props, {
            editIndex: i,
            initialValues: contentItem,
            isEdit: true
          }));
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-xs btn-danger",
        type: "button",
        onClick: function onClick() {
          return handleDelete(i, displayName);
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))), /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].title
      }, displayName));
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section,
    style: {
      paddingBottom: isExpanded ? '22px' : '0px'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: 'btn btn-link ' + _style["default"].title,
    onClick: function onClick() {
      return setIsExpanded(function (prev) {
        return !prev;
      });
    },
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "fs-6"
  }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceRight: true
  }), title)), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("small", null, summary)), isExpanded && /*#__PURE__*/_react["default"].createElement("div", null, Array.isArray(content) && content.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "pinned".concat(moduleIndex || moduleIndex === 0 ? moduleIndex : '_').concat(surveyHandle ? surveyHandle : '_')
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), content.map(renderContent), provided.placeholder);
  })), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    contentStyle: {
      maxWidth: '1300px'
    },
    size: "calc(100vw - 50px)",
    title: 'Add pinned content to ' + title,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
      spaceRight: true
    }), "Add Pinned Content"),
    render: function render(_ref2) {
      var closeModal = _ref2.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_Form["default"], _extends({
        closeModal: closeModal
      }, props));
    }
  })));
};
var _default = exports["default"] = PinnedContentSection;